<template>
    <div   :style="{
        backgroundColor: currentPageConfig?.info?.backgroundColor,
        backgroundImage: localizedPageBackground
            ? `url(${localizedPageBackground})`
            : ''
    }" :class="{
        'page-wrap': isPage,
        'page-wrap--mobile': isPage && isMobile,
    }" @contextmenu="onContextmenu">
        <div v-if="currentPageConfig">
            <div v-for="(item, idx) in currentPageConfig.elements" :key="idx">
                <element-item :disabled="!edit" :item-data="item" :idx="idx"
                    :allArcListMap="activeDetailData?.allArcListMap || {}" :parentKeys="[]"
                    :list-length="currentPageConfig.elements.length"
                    :currentElementIndex="currentElementIndex" :current="idx + '' === currentElementIndexStr"
                    :pages="activeDetailData?.pages || []"></element-item>
            </div>
        </div>
        <SiteEmpty v-else />
    </div>
</template>

<script setup>

import { computed, watch } from 'vue';
import SiteEmpty from '~/components/common/SiteEmpty.vue';
import ElementItem from '~/components/render/ElementIndex.vue';
import { resolveLocalizedAssetUrl } from '~/utils/lowCodeLocalizedAsset.js';
import { redirectLowCodePageByDevice } from '~/utils/lowCodeDeviceRedirect.js';




const props = defineProps({
    isMobile: {
        type: Boolean,
        default: false,
    },
    activeDetailData: {
        type: Object,
        default: () => ({}),
    },
    edit: {
        type: Boolean,
        default: false,
    },
    isPage: {
        type: Boolean,
        default: true,
    },
    currentElementIndex: {
        type: Array,
        default: () => ([]),
    },
    currentElementIndexStr: {
        type: String,
        default: "",
    },
});
const currentPageConfig = computed(() => props.activeDetailData?.currentPageConfig || null);
const { locale } = useI18n();
const localizedPageBackground = computed(() =>
    resolveLocalizedAssetUrl(
        currentPageConfig.value?.info,
        'backgroundImage',
        locale.value,
    )
);
watch(
    () => currentPageConfig.value?.info,
    (pageInfo) => {
        if (!props.edit && props.isPage && pageInfo) {
            redirectLowCodePageByDevice(pageInfo);
        }
    },
    { immediate: true }
);
const emit = defineEmits(['contextmenu'])
function onContextmenu(event) {
    emit("contextmenu", event)
}


</script>

<style scoped>
.page-wrap {
    min-height: 100vh;
    min-width: 1200px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
}

.page-wrap--mobile {
    min-width: auto;
}

@media (max-width: 1199px) {
    .page-wrap {
        min-width: auto;
    }
}
</style>
